// services scroll logic
const servicesScrollContainer = document.querySelectorAll(
	'.services-scroll-container',
)
if (servicesScrollContainer) {
	const servicesScrollThumb = document.querySelector('.services-scroller-thumb')
	const baseThumbWidth = 0
	let currThumbWidth = baseThumbWidth
	let scrollPercentage = 0

	if (servicesScrollThumb) {
		servicesScrollThumb.style.width = `${currThumbWidth}px`
	}

	servicesScrollContainer.forEach((container) => {
		container.addEventListener('scroll', (ev) => {
			const scrollThumbContainerWidth =
				servicesScrollThumb?.parentElement.clientWidth
			const scrollAmount = container.scrollWidth - container.clientWidth
			const currScroll = ev.target.scrollLeft

			scrollPercentage = currScroll / scrollAmount
			currThumbWidth =
				scrollPercentage * (scrollThumbContainerWidth - baseThumbWidth) +
				baseThumbWidth
			if (servicesScrollThumb) {
				servicesScrollThumb.style.width = `${currThumbWidth}px`
			}
		})
	})
}

export default servicesScrollContainer
